<template>
  <div v-click-outside="closeSetter">
    <div class="input-time" @click="showChange = true">
      {{ formattedTime }}

      <div class="time-setter" v-if="showChange">
        <VueNumericInput v-model="hh" placeholder="HH" :min="0" :max="24" :step="1" size="normal" width="90px" />
        <span class="d-inline-block mx-2">:</span>
        <VueNumericInput v-model="mm" placeholder="MM" :min="0" :max="59" :step="minuteInterval ? minuteInterval : 1" size="normal" width="90px" />
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import VueNumericInput from 'vue-numeric-input';

export default {
  name: 'InputTime',
  directives: {
    ClickOutside,
  },
  components: {
    VueNumericInput,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    minuteInterval: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      hh: 0,
      mm: 0,
      showChange: false,
    };
  },
  computed: {
    formattedTime() {
      if (this.hh || this.mm) {
        let hhMM = '';
        if (this.hh) {
          hhMM += this.formattedHH;
        } else {
          hhMM += '0';
        }

        hhMM += ':';

        if (this.mm) {
          hhMM += this.formattedMM;
        } else {
          hhMM += '0';
        }

        return hhMM;
      }

      return '0:00';
    },
    formattedHH() {
      if (this.hh) {
        if (this.hh < 10) {
          return `0${this.hh}`;
        }
        return this.hh;
      }

      return '';
    },
    formattedMM() {
      if (this.mm) {
        if (this.mm < 10 && this.mm !== '00') {
          return `0${this.mm}`;
        }
        return this.mm;
      }
      return '';
    },
  },
  watch: {
    value() {
      this.parseTime();
    },
    showChange() {
      if (!this.showChange) {
        this.saveTime();
      }
    },
  },
  mounted() {
    this.parseTime();
  },
  methods: {
    parseTime() {
      if (this.value) {
        const time = this.value.split(':');
        // eslint-disable-next-line prefer-destructuring
        this.hh = time[0].replace('0', '');
        // eslint-disable-next-line prefer-destructuring
        this.mm = time[1];
      }
    },
    saveTime() {
      const timeToSet = `${this.formattedHH}:${this.formattedMM}`;

      if (timeToSet !== this.value) {
        this.$emit(
          'close',
          `${this.formattedHH ? this.formattedHH : '0'}:${
            this.formattedMM ? this.formattedMM : '0'
          }`,
        );
      }
    },
    increaseHours() {
      this.hh += 1;
    },
    decreaseHours() {
      this.hh -= 1;
    },
    closeSetter() {
      this.showChange = false;
    },
  },
};
</script>

<style scoped lang="scss">
.input-time {
  position: relative;
  padding: 5px 10px;

  .time-setter {
    position: absolute;
    display: flex;
    background-color: #eeeeee;
    padding: 10px;
    z-index: 10;
    left: 0;
    border: 1px solid #d9d9d9;
    align-items: center;

    input {
      width: 70px;
      background-color: #f6f6f6;
      padding: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InputTime.vue